import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { LoaderService } from '@ff/loader';
import { UserService } from '@ff/user';


@Injectable()
export class UserResolver implements Resolve<any> {

  constructor(private _userService: UserService) {
  }

  resolve() {
    return this._userService.getUser().getValue();
  }
}
